module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/fails.js
// module id = 65
// module chunks = 0